module.exports = __webpack_public_path__ + "img/saoma.0dffadc0.png";